import { Component } from '@angular/core';

@Component({
    selector: 'app-operators',
    templateUrl: './operators.component.html',
    styleUrls: ['./operators.component.scss'],
    standalone: false
})
export class OperatorsComponent {}
